import { postAction } from '@/utils/api'

// 用户名密码登录
export function login (data) {
  return postAction('/performance/login/info', data)
}
// CA用户令牌登录
export function loginCA (data) {
  return postAction('/performance/sso/login', data)
}



// WEBPACK FOOTER //
// ./src/api/login.js